// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {TreeItem} from '@material-ui/lab';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
  },
  button: {
    backgroundColor: '#e6e6e6',
    borderColor: 'white',
    borderRadius: 8,
    height: '32px',
    fontSize: 16,
    paddingLeft: '8px',
    paddingRight: '8px',
  },
}));

const FolderTreeItem = ({children, label, folderData, folderData: {folderID: folderId}, onClick, parentFolderData}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TreeItem
        label={
          <button className={classes.button} onClick={() => onClick({...folderData, parents: parentFolderData})}>
            {label}
          </button>
        }
        nodeId={folderId}
      >
        {typeof children === 'function' ? children() : children}
      </TreeItem>
    </div>
  );
};

FolderTreeItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  folderData: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  parentFolderData: PropTypes.array.isRequired,
};

export default FolderTreeItem;
